class Performance {
  constructor({ id, workoutId, exerciseId, completedAt, valueLeft, valueRight, sets = 1, notes }) {
    this.id          = id
    this.workoutId   = workoutId
    this.exerciseId  = exerciseId
    this.completedAt = completedAt
    this.valueLeft   = valueLeft
    this.valueRight  = valueRight
    this.sets        = sets ?? 1
    this.notes       = notes
  }
}

export default Performance
